var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-header-container"},[_c('PtHeader',{attrs:{"service":_vm.headerService},scopedSlots:_vm._u([{key:"logo",fn:function(){return [_c('LogoPatSnap')]},proxy:true},{key:"timer",fn:function(){return [(_vm.caseTimeService)?_c('PtHeaderWidgetCaseTime',{attrs:{"service":_vm.caseTimeService}}):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }